import React from 'react';

import { AnimatePresence } from 'framer-motion';

import useModals from '../hooks/useModals';

import QueryModal from './queryModal';

const QueryNotifications = () => {
  const { modals } = useModals();

  return (
    <AnimatePresence>
      {modals.map((modal) => (
        <QueryModal key={modal.id} modal={modal} />
      ))}
    </AnimatePresence>
  );
};

export default React.memo(QueryNotifications);
